import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AddRestaurantLayer from "../../components/restaurants/AddRestaurantLayer";


const AddRestaurantPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Add New Restaurant" />

        {/* AddUserLayer */}
        <AddRestaurantLayer />


      </MasterLayout>
    </>
  );
};

export default AddRestaurantPage;
